import { render, staticRenderFns } from "./OrderItemSelect.vue?vue&type=template&id=3bf6af09&"
import script from "./OrderItemSelect.vue?vue&type=script&lang=js&"
export * from "./OrderItemSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports